import { ComponentProps } from "react";
import "./index.scss";

interface ActionButtonProps extends ComponentProps<"button"> {
  icon?: React.ReactNode;
  label: string;
}

export const ActionButton = ({ icon, label, ...props }: ActionButtonProps) => {
  return (
    <button
      id="action-button"
      className="btn btn-sm text-muted p-0"
      title="Salvar"
      {...props}
    >
      {icon && icon} {label}
    </button>
  );
};
